import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-catalog-copy',
  templateUrl: './add-catalog-copy.component.html',
  styleUrls: ['./add-catalog-copy.component.css']
})
export class AddCatalogCopyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
